export const getToolDeviceId = (args: unknown): string => {
  if (typeof args !== "object" || args === null || !("device_id" in args)) {
    return "";
  }

  return typeof args.device_id === "string" ? args.device_id.trim() : "";
};
